// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5400":"754965f9","9131":"754965f9"}[chunkId] + ".chunk.css";
};